"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isServerConfigurationWithAdminSecret = exports.isServerConfigurationWithClientSecret = exports.isServerConfiguration = exports.isBaseConfiguration = exports.isAdminSecret = exports.isClientSecret = exports.isAPIKey = exports.isDomain = void 0;
var isDomain = function (domain) {
    return typeof domain === 'string' && domain.length > 6;
};
exports.isDomain = isDomain;
var isAPIKey = function (value) {
    return typeof value === 'string' && value.length > 2;
};
exports.isAPIKey = isAPIKey;
var isClientSecret = function (clientSecret) {
    return typeof clientSecret === 'string' && clientSecret.length > 3;
};
exports.isClientSecret = isClientSecret;
var isAdminSecret = function (adminSecret) {
    return typeof adminSecret === 'string' && adminSecret.length > 3;
};
exports.isAdminSecret = isAdminSecret;
var isBaseConfiguration = function (config) {
    return (0, exports.isAPIKey)(config === null || config === void 0 ? void 0 : config.apiKey) &&
        (0, exports.isDomain)(config === null || config === void 0 ? void 0 : config.serviceDomain) &&
        typeof (config === null || config === void 0 ? void 0 : config.serviceUseHttps) === 'boolean';
};
exports.isBaseConfiguration = isBaseConfiguration;
var isServerConfiguration = function (config) {
    var _a, _b;
    return typeof (config === null || config === void 0 ? void 0 : config.useHttps) === 'boolean' &&
        (0, exports.isDomain)(config === null || config === void 0 ? void 0 : config.server) &&
        typeof (config === null || config === void 0 ? void 0 : config.path) === 'string' && config.path.length > 2 &&
        (typeof (config === null || config === void 0 ? void 0 : config.clientSecret) === 'undefined' || (0, exports.isClientSecret)(config === null || config === void 0 ? void 0 : config.clientSecret)) &&
        (typeof (config === null || config === void 0 ? void 0 : config.adminSecret) === 'undefined' || (0, exports.isAdminSecret)(config === null || config === void 0 ? void 0 : config.adminSecret)) &&
        (typeof (config === null || config === void 0 ? void 0 : config.version) === "undefined" ||
            (typeof ((_a = config === null || config === void 0 ? void 0 : config.version) === null || _a === void 0 ? void 0 : _a.id) === 'number' &&
                typeof ((_b = config === null || config === void 0 ? void 0 : config.version) === null || _b === void 0 ? void 0 : _b.readable) === 'string')) &&
        (0, exports.isAPIKey)(config === null || config === void 0 ? void 0 : config.apiKey);
};
exports.isServerConfiguration = isServerConfiguration;
var isServerConfigurationWithClientSecret = function (config) {
    return typeof (config === null || config === void 0 ? void 0 : config.clientSecret) === 'string' && (0, exports.isServerConfiguration)(config);
};
exports.isServerConfigurationWithClientSecret = isServerConfigurationWithClientSecret;
var isServerConfigurationWithAdminSecret = function (config) {
    return typeof (config === null || config === void 0 ? void 0 : config.adminSecret) === 'string' && (0, exports.isServerConfiguration)(config);
};
exports.isServerConfigurationWithAdminSecret = isServerConfigurationWithAdminSecret;
